/* eslint-disable global-require */
import i18n from 'i18next'
import { merge } from 'lodash'
import { initReactI18next } from 'react-i18next'
import { getCmsContent } from 'services/api/headlessCms'
import {
  getHeadlessCmsBrandName,
  getTranslationPathBrandName,
} from 'services/brand'

const NAMESPACES = [
  'page',
  'validation',
  'error',
  'linkExpiry',
  'form',
  'app',
  'step1',
  'step2',
  'step3',
  'step4',
  'dealerLanding',
  'customerHappinessIndex',
  'priceValidation',
]

export const initI18n = async () => {
  const appBrandName = process.env.REACT_APP_WEBSITE_BRAND
  const translationPathBrandName = getTranslationPathBrandName(appBrandName)
  const cmsBrandName = getHeadlessCmsBrandName(appBrandName)

  await i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      resources: {},
      lng: 'pl',
      keySeparator: '.', // we do not use keys in form messages.welcome
      interpolation: {
        escapeValue: false, // react already safes from xss
        format: (value, format) => {
          if (typeof value !== 'string') return value

          if (format === 'lowercase') {
            return value.toLowerCase()
          }

          return value
        },
      },
    })

  await Promise.all(
    NAMESPACES.map(item => {
      return Promise.all([
        import(
          `../../resources/common-brands/content/${item}.json`
        ).catch(() => ({ default: {} })),
        import(
          `../../resources/${translationPathBrandName}/content/${item}.json`
        ).catch(() => ({
          default: {},
        })),
      ]).then(([genericModule, brandModule]) => {
        i18n.addResourceBundle(
          'pl',
          item,
          merge({}, genericModule.default, brandModule.default),
          true,
          true
        )
      })
    })
  )

  await getCmsContent('v1', cmsBrandName, 'pl').then(content => {
    i18n.addResourceBundle('pl', 'headlessCms', content, true, true)
  })
}

export default i18n
